import React from 'react';
import { useWindowScroll, usePrevious } from 'react-use';
import classNames from 'classnames';
import { useIntl } from 'react-intl';

export default () => {
  const { y } = useWindowScroll();
  const prevY = usePrevious(y);
  const { formatMessage } = useIntl();

  const onClick = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <button
      className={classNames('goup', { visible: y > prevY })}
      onClick={onClick}
      title={formatMessage({
        id: 'scroll-to-top-title',
        defaultMessage: 'Scroll to the top of the page',
      })}
    >
      <span />
    </button>
  );
};
